import { render } from "./DxtPackageTopUpLog.vue?vue&type=template&id=327124cc&scoped=true"
import script from "./DxtPackageTopUpLog.vue?vue&type=script&lang=js"
export * from "./DxtPackageTopUpLog.vue?vue&type=script&lang=js"

import "./DxtPackageTopUpLog.vue?vue&type=style&index=0&id=327124cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-327124cc"

export default script